import React from 'react'
import Header from '../Layout/Header'
import AffiliateBanner from './AffiliateBanner'
import FAQs from '../Pricing/PricingSections/FAQs'
import Testimonials from '../Home/HomeSections/Testimonials'
import Lorem from '../Home/HomeSections/Lorem'
import Footer from '../Layout/Footer'

export default function Affiliate() {
  return (
    <div>
        <Header/>
        <AffiliateBanner/>
        <FAQs/>
        <Testimonials/>
        <Lorem/>
        <Footer/>
    </div>
  )
}
